import CircleLoader from './CircleLoader';
import RectangleLoader from './RectangleLoader';
import LoadingIndicator from './LoadingIndicator';

export { CircleLoader, LoadingIndicator, RectangleLoader };
